// ------------------------------------
// Constants
// ------------------------------------

export const SHOW_HEADER_MENU = 'farmakom/showHeaderMenu/SHOW_HEADER_MENU';

// ------------------------------------
// Actions
// ------------------------------------

export function showHeaderMenu(headerMenuOpen) {
  return {
    type: SHOW_HEADER_MENU,
    payload: headerMenuOpen
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  headerMenuOpen: false,
};

export default function showHeaderMenuReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_HEADER_MENU:
      return {
        ...state,
        headerMenuOpen: action.payload,
      };
    default:
      return state;
  }
}